export const getCoords = cell => {
  if (cell) {
    const coord = { X: cell.X * 86 + 43 * (Math.abs(cell.Y) % 2), Y: cell.Y * 73 };
    return coord;
  } else {
    return null;
  }
};